import React, { useState } from 'react';
import { auditInventoryItems } from '../utils/inventoryAudit';

export default function InventoryAuditPage() {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState('dry');
  const [error, setError] = useState(null);

  const runAudit = async (dryRun) => {
    setLoading(true);
    setError(null);
    setResult(null);
    setMode(dryRun ? 'dry' : 'update');
    try {
      const res = await auditInventoryItems({ dryRun });
      setResult(res);
    } catch (err) {
      setError(err.message || 'Error running audit');
    }
    setLoading(false);
  };

  return (
    <div style={{ padding: 32, maxWidth: 600, margin: '0 auto' }}>
      <h1>Inventory Data Audit</h1>
      <p>This tool checks for missing <b>on_hand</b>, <b>par_level</b>, and <b>branch</b> fields in your inventoryItems collection.</p>
      <div style={{ margin: '24px 0' }}>
        <button onClick={() => runAudit(true)} disabled={loading} style={{ marginRight: 12 }}>
          {loading && mode === 'dry' ? 'Running...' : 'Run Dry-Run Audit'}
        </button>
        <button onClick={() => runAudit(false)} disabled={loading} style={{ background: '#4caf50', color: '#fff' }}>
          {loading && mode === 'update' ? 'Updating...' : 'Apply Fixes'}
        </button>
      </div>
      {error && <div style={{ color: 'red', marginBottom: 16 }}>{error}</div>}
      {result && (
        <div style={{ background: '#f8f8f8', borderRadius: 8, padding: 20, marginTop: 16 }}>
          <h3>Audit Results</h3>
          <ul>
            <li><b>Total items:</b> {result.total}</li>
            <li><b>Missing on_hand:</b> {result.missingOnHand}</li>
            <li><b>Missing par_level:</b> {result.missingParLevel}</li>
            <li><b>Missing branch:</b> {result.missingBranch}</li>
            <li><b>Items needing update:</b> {result.updates}</li>
          </ul>
          <p style={{ color: '#888', fontSize: 13 }}>
            {mode === 'dry' ? 'No changes made (dry run).' : 'Updates applied to Firestore.'}
          </p>
        </div>
      )}
    </div>
  );
} 